<template>
	<div v-bind:class="styleItem" class="gb-photoalbum-select-list-row-item" v-on:click="onClick">
		<GBPhotoAlbumItemNotReference v-if="!item.reference" />
		<div class="gb-photoalbum-select-list-row-item-content">
			<div class="name">{{ item.name }}</div>
			<div class="schedule-title" v-if="showSchedule">{{ item.title }}<br></div>
			<div class="m-schedule" v-if="showSchedule">{{ item.schedule }}</div>
		</div>
	</div>
</template>
<script>
import GBPhotoAlbumItemNotReference from './GBPhotoAlbumItemNotReference';

export default {
	name: 'GBPhotoAlbumSelectListRow',
	props: [
		"item",
		"select_id",
	],
	components: {
		GBPhotoAlbumItemNotReference,
	},
	methods: {
		onClick: function() {
			this.$emit('select-list', this.item.id);
		},
	},
	computed: {
		selected: function() {
			if (!this.select_id)
				return false;
			return this.item.id === this.select_id;
		},
		styleItem: function() {
			let classes = new Array();
			if (!this.selected)
				classes.push('unselected');
			else
				classes.push('selected');
			
			return classes;
		},
		showSchedule: function() {
			return this.item.schedule !== undefined && this.item.schedule !== null;
		},
	},
}
</script>
<style>
.gb-photoalbum-select-list-row-item {
	position: relative;
	flex: 1 1 auto;
	overflow: hidden;
	width: 299px;
	height: 61px;
	border-bottom: 1px solid #a9a9a9;
}
.gb-photoalbum-select-list-row-item.selected {
	background-color: #e0ffff;
}

.gb-photoalbum-select-list-row-item.unselected {
	background-color: #fefefe;
}
.gb-photoalbum-select-list-row-item-content {
	height: 60px;
	padding: .25em;
}
.gb-photoalbum-select-list-row-item .name {
	height: 1.5em;
	word-wrap: normal;
	overflow: hidden;
}
.gb-photoalbum-select-list-row-item .schedule-title {
	font-size: 12px;
	word-wrap: normal;
	overflow: hidden;
	height: 1.5em;
}
.gb-photoalbum-select-list-row-item .m-schedule {
	height: 1.5em;
	color: #2196f3;
	font-size: 12px;
}
</style>
